import cn from "classnames";
import Pagination from "components/shared/reactTable/pagination";
import { splitKeyFromProps } from "helpers/reactTableProps";
import React, { useEffect, useState } from "react";
import { useFlexLayout, usePagination, useResizeColumns, useTable } from "react-table";

const Table = (props) => {
    const [openedDropd, setOpenedDropd] = useState(null);
    const instance = useTable(
        { ...props, autoResetPage: false, initialState: { ...props.initialState, pageIndex: 0, pageSize: 30 } },
        useResizeColumns,
        useFlexLayout,
        usePagination,
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageCount,
        page,
        state: { pageIndex, pageSize },
        gotoPage,
        setPageSize,
    } = instance;

    useEffect(() => {
        gotoPage(0);
    }, [props.filtersUpdatedAt]);

    const { pageSizeOptions, sortBy, sorted, storeColumnWidth, withoutPagination } = props;

    const { columnResizing } = instance.state;
    useEffect(() => {
        storeColumnWidth(columnResizing);
    }, [columnResizing]);

    const paginationProps = {
        page: pageIndex,
        pages: pageCount,
        pageSize,
        pageIndex,
        onPageChange: gotoPage,
        onPageSizeChange: setPageSize,
        pageSizeOptions,
    };
    const iconClass = (column, direction, baseClass) =>
        cn(baseClass, {
            "r-table__sort-icon--active": column.id === sorted.column && direction === sorted.direction,
            "r-table__sort-icon--disabled": column.id === sorted.column && direction !== sorted.direction,
        });

    const renderDropd = (column, index) => {
        return (
            openedDropd &&
            openedDropd === index && (
                <ul className="c-dropd__list no-bullet">
                    <li
                        className={cn("c-dropd__list-item", {
                            "font-weight-bold":
                                column.id === sorted.column &&
                                ["planEndDate", "estimatedLeaveDate"].includes(sorted.field),
                        })}
                        onClick={() => sortBy(column, props.byPlanDate ? "planEndDate" : "estimatedLeaveDate")}
                    >
                        По времени выезда
                    </li>
                    <li
                        className={cn("c-dropd__list-item", {
                            "font-weight-bold": column.id === sorted.column && sorted.field === "withoutBidPeriod",
                        })}
                        onClick={() => sortBy(column, "withoutBidPeriod")}
                    >
                        По простою
                    </li>
                </ul>
            )
        );
    };

    const openDropd = (index) => {
        if (index === openedDropd) {
            closeDropd();
        } else {
            closeDropd();
            setTimeout(() => {
                setOpenedDropd(index);
                document.addEventListener("click", closeDropd);
            }, 0);
        }
    };

    const closeDropd = () => {
        setOpenedDropd(null);
        document.removeEventListener("click", closeDropd);
    };

    return (
        <>
            <div {...getTableProps()} className="r-table table-sm">
                <div className="r-table__thead">
                    {headerGroups.map((headerGroup, i) => {
                        const { key: headerGroupKey, props: headerGroupProps } = splitKeyFromProps(
                            headerGroup.getHeaderGroupProps(),
                        );
                        return (
                            <div key={headerGroupKey ?? i} {...headerGroupProps} className="tr">
                                {headerGroup.headers.map((column, i) => {
                                    const { key: headerKey, props: headerProps } = splitKeyFromProps(
                                        column.getHeaderProps(),
                                    );
                                    return (
                                        <div key={headerKey ?? i} {...headerProps} className="th">
                                            <div
                                                className={cn("r-table__column-title r-table__column-title--sortable", {
                                                    "bg-light-danger": column.isWeekend,
                                                })}
                                                onClick={() =>
                                                    column.columnType === "date" ? openDropd(i) : sortBy(column)
                                                }
                                            >
                                                {column.render("Header")}
                                                <span className="r-table__sort-icon">
                                                    <i
                                                        className={iconClass(
                                                            column,
                                                            "desc",
                                                            "r-table__sort-icon--down",
                                                        )}
                                                    />
                                                    <i className={iconClass(column, "asc", "r-table__sort-icon--up")} />
                                                </span>
                                            </div>
                                            {renderDropd(column, i)}
                                            {column.filterable && (
                                                <div className="r-table__column-filter">{column.render("Filter")}</div>
                                            )}
                                            <div
                                                {...column.getResizerProps()}
                                                className={`r-table__resizer ${column.isResizing ? "isResizing" : ""}`}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
                <div className="r-table__tbody" {...getTableBodyProps()}>
                    {page.map((row, i) => {
                        prepareRow(row);
                        const { key: rowKey, props: rowProps } = splitKeyFromProps(row.getRowProps());
                        return (
                            <div key={rowKey ?? i} {...rowProps} className="tr">
                                {row.cells.map((cell, i) => {
                                    const { key: cellKey, props: cellProps } = splitKeyFromProps(cell.getCellProps());
                                    return (
                                        <div
                                            key={cellKey ?? i}
                                            {...cellProps}
                                            className={cn("td", { "bg-light-danger": cell.column.isWeekend })}
                                        >
                                            {cell.render("Cell")}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                    {page.length === 0 && <div className="rt-noData">Нет данных для отображения</div>}
                </div>
            </div>
            {!withoutPagination && (
                <div className="r-table__tfoot">
                    <Pagination isNotExportable {...paginationProps} />
                </div>
            )}
        </>
    );
};

export default Table;
